import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDataChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M3 0a3 3 0 1 0 1.533 5.58l1.653 1.377A3 3 0 0 0 9 11c1.78 0 3.194-1.615 2.977-3.371l.94-.47A3 3 0 1 0 15 2c-1.78 0-3.193 1.614-2.977 3.37l-.94.47A2.99 2.99 0 0 0 9 5c-.56 0-1.084.153-1.533.42L5.814 4.044A3 3 0 0 0 3 0ZM2 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm12 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM9 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		d: "M1 8v10h2V8H1Zm14 10v-8h2v8h-2Zm-7 0v-5h2v5H8Z"
	})]
});
export default SvgDataChart;
